import { Directive, OnDestroy, OnInit, Optional, Self } from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { Subscription } from 'rxjs';

@Directive({
  selector: 'p-dialog'
})
export class DialogDefaultsDirective implements OnInit, OnDestroy {
  private subscription = new Subscription();
  private savedScrollY: number | null = null;

  constructor(@Self() @Optional() private dialog: Dialog) {}

  ngOnInit(): void {
    if (!this.dialog) return;

    if (!this.dialog.appendTo) {
      this.dialog.appendTo = 'body';
    }

    // Intercept visible setter to capture scroll position immediately before opening
    const proto = Object.getPrototypeOf(this.dialog);
    const desc = Object.getOwnPropertyDescriptor(proto, 'visible');
    if (desc && desc.set) {
      const originalSet = desc.set;
      const originalGet = desc.get;
      const self = this;
      Object.defineProperty(this.dialog, 'visible', {
        get() {
          return originalGet ? originalGet.call(this) : this._visible;
        },
        set(value: any) {
          if (value && self.savedScrollY === null && typeof window !== 'undefined') {
            self.savedScrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
          }
          originalSet.call(this, value);
        },
        configurable: true
      });
    }

    // Restore scroll position when dialog closes
    this.subscription.add(
      this.dialog.onHide.subscribe(() => {
        this.restoreScrollPosition();
      })
    );
  }

  ngOnDestroy(): void {
    this.restoreScrollPosition();
    this.subscription.unsubscribe();
  }

  private restoreScrollPosition(): void {
    if (this.savedScrollY !== null && typeof window !== 'undefined') {
      const targetY = this.savedScrollY;
      this.savedScrollY = null;
      requestAnimationFrame(() => {
        window.scrollTo(0, targetY);
      });
    }
  }
}
